import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Hero } from '../../../../../components/UpliftAds/components/Banner/components/Hero/index.js';
import { Inline } from '../../../../../components/UpliftAds/components/Banner/components/Inline/index.js';
import { Recommender } from '../../../../../components/UpliftAds/components/Banner/components/Recommender/index.js';
import { Skyscraper } from '../../../../../components/UpliftAds/components/Banner/components/Skyscraper/index.js';
import { Tile } from '../../../../../components/UpliftAds/components/Banner/components/Tile/index.js';
export const Base = ({
  category,
  content,
  ...props
}) => {
  switch (category) {
    case 'inline':
      return _jsx(Inline, {
        ...props,
        title: content.ctHeading,
        subtitle: content.ctSubheading,
        image: content.ctImage,
        logo: content.ctLogo
      });
    case 'recommender':
      return _jsx(Recommender, {
        ...props,
        title: content.ctHeading,
        subtitle: content.ctSubheading,
        image: content.ctImage,
        price: content.ctPrice
      });
    case 'skyscraper':
      return _jsx(Skyscraper, {
        ...props,
        imageDesktop: content.ctDesktop,
        imageTablet: content.ctTablet,
        imageMobile: content.ctMobile
      });
    case 'tile':
      return _jsx(Tile, {
        ...props,
        category: Number(content.ctStarRating),
        title: content.ctHeadline,
        subtitle: content.ctSubheading,
        hotel: content.ctHotelName,
        image: content.ctHotelImage
      });
    default:
      return _jsx(Hero, {
        ...props,
        title: content.ctHeading,
        subtitle: content.ctSubheading,
        image: content.ctImage,
        logo: content.ctLogo
      });
  }
};